import "./styles.css"
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import { db } from "../../firebaseFunctions/authhook";

import {
    collection,
    addDoc,
    getDocs,
    query,
    onSnapshot,
    orderBy,
    deleteDoc,
    doc,
    updateDoc,
} from "firebase/firestore";
import { useContext, useEffect, useState } from "react";
import { idContext } from "../../App";
const Home: React.FC = () => {
    const navigate = useNavigate();
    const usersCollectionRef = collection(db, "appointment_lists");
    const seatCollectionRef = collection(db, "seatAvailablePerDay");
    const timeSchedulingRef = collection(db, "timeScheduling");

    const [quantity, setQuantity] = useState(1)
    const [id, setId] = useContext(idContext);
    const [timesData, setTimesData] = useState<object | any>({
        openingTime: '',
        closingTime: ''
    });
    const [seatdata, setSeatData] = useState<DocumentType[] | any>([])

    useEffect(() => {
        const getUsers = async () => {
            const userCollection = query(usersCollectionRef, orderBy('createdAt', 'asc'));
                                const userData = await getDocs(userCollection);
                                const userdat = userData.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                            console.log(userdat);
                            
            const t = query(timeSchedulingRef);
            onSnapshot(t, (snapshot) => {
                const times = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                setTimesData(times[0])
            })
            const s = query(seatCollectionRef)
            onSnapshot(s, (snapshot) => {
                const seat = snapshot.docs.map((doc) => doc.data());
                setSeatData(seat)
            })
        };
        getUsers();
    }, []);
    
    return (
        <div dir="rtl" className="home">
            <div className="">
                <p dir="rtl" className="homeHeader-Text">لحجز موعد، من فضلك ملئ البيانات</p>
                <Formik
                    initialValues={{
                        firstName: "",
                        numberMob: "",
                    }}
                    validationSchema={Yup.object().shape({
                        firstName: Yup.string()
                            .min(4, 'الأسم قصير جداً')
                            .max(15, 'الأسم طويل جداً')
                            .required("الرجاء أدخال الإسم"),
                        numberMob: Yup.string()
                            .required("الرجاء أدخال رقم الجوال")
                            .matches(
                                /.{10,}/,
                                "١٠ ارقام. مطلوبة"
                            )
                    })}
                    onSubmit={async ({ firstName, numberMob }, { setStatus, setSubmitting }) => {
                        setSubmitting(true);

                        const d = new Date();
                        let currentTime = d.getHours() * 3600 + d.getMinutes() * 60;
                        const open = timesData.openingTime.split(':');
                        const close = timesData.closingTime.split(':');


                        const openTimeInSeconds = parseFloat(open[0]) * 3600 + parseFloat(open[1]) * 60;
                        const closingTimeInSeconds = parseFloat(close[0]) > 0 && parseFloat(close[1]) > 0 ? (parseFloat(close[0]) * 3600 + parseFloat(close[1]) * 60) : 86400;

                        if (currentTime >= openTimeInSeconds && currentTime <= closingTimeInSeconds) {
                            let x: any = [];
                            for (let i = 1; i <= quantity; i++) {
                                const res = await addDoc(usersCollectionRef, { firstName, mobileNumber: numberMob, date: new Date().toDateString(), createdAt: new Date() });
                                x.push(res.id)
                            }
                            if (x.length > 0) {
                                const userCollection = query(usersCollectionRef, orderBy('createdAt', 'asc'));
                                const userData = await getDocs(userCollection);
                                const userdat = userData.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
                                const find = userdat.findIndex((data) => data.id ===  x[0]);
                                const findNumber = userdat.filter((data: any) => data.mobileNumber === numberMob);
                                
                                if (find + quantity - 1 < parseInt(seatdata[0].totalNumberOfSeat) && findNumber.length < 3) {
                                   await userdat.map(async ({id}, index)=>{
                                        const userDoc = doc(db, "appointment_lists", id);
                                        const newFields = { serialNumber: id === x[0] && quantity === 2 ? `${ 1 + index} and ${2 + index}` : 1 + index, indexNumber: 1  + index};
                                        await updateDoc(userDoc, newFields);
                                    })
                                    setId(x[0])
                                    return navigate('success')
                                }
                                else if (find + quantity - 1 <= parseInt(seatdata[0].totalNumberOfSeat) && findNumber.length >= 2) {
                                    x.map(async (id: any) => {
                                        await deleteDoc(doc(db, "appointment_lists", id));
                                    })
                                    return navigate('error')
                                }                            
                                else if (find + quantity - 1 > parseInt(seatdata[0].totalNumberOfSeat)) {
                                    x.map(async (id: any) => {
                                        await deleteDoc(doc(db, "appointment_lists", id));
                                    })
                                    return navigate('error')
                                }
                                                        
                            }
                        }
                        else {
                            navigate('close')
                        }
                        setSubmitting(false);
                    }}
                >
                    {({ errors, status, touched, isSubmitting }) => (
                        <Form>
                            <div dir="rtl" className="labelDesign">
                                <label>
                                    <Field
                                        className="inputDesign"
                                        name="firstName"
                                        type="text"
                                        placeholder="ادخل الأسم"
                                    />
                                    {errors.firstName && touched.firstName ? (
                                        <div>
                                            <small style={{ color: "red" }}>{errors.firstName}</small>
                                        </div>
                                    ) : null}
                                </label>
                            </div>

                            <div className="labelDesign">
                                <label>
                                    <Field
                                        className="inputDesign"
                                        name="numberMob"
                                        type="text"
                                        placeholder="ادخل رقم الجوال"
                                    />
                                    {errors.numberMob && touched.numberMob ? (
                                        <div>
                                            <small style={{ color: "red" }} >{errors.numberMob}</small>
                                        </div>
                                    ) : null}
                                    {status && <small style={{ color: "red" }}>{status}</small>}
                                </label>
                            </div>
                            <div dir="rtl" className="quantityDesign">
                                <p>عدد الحضور</p>
                                <div>
                                    <AiOutlineMinus onClick={() => setQuantity((curr) => curr > 1 ? curr - 1 : curr)} />
                                    <p>0{quantity}</p>
                                    <AiOutlinePlus onClick={() => setQuantity((curr) => curr < 2 ? curr + 1 : curr)} />
                                </div>
                            </div>
                            <div className="flex_design home_flex">
                                <p dir="rtl" className="homeMessage">
                                    يجب الحضور قبل الموعد بـ 15 دقيقة في حال لم يتم الحضور يعتبر الحجز ملغي
                                </p>
                                <button
                                    type="submit"
                                    className="cta homeBottomText"
                                >
                                    {
                                        isSubmitting ?
                                            <ClipLoader color={'#ffffff'} loading={isSubmitting} size={40} />
                                            :
                                            'تأكيد الحجز'
                                    }
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}
export default Home;
